import { FileText, Truck, Receipt } from 'lucide-react';

export const TIPI_PAGAMENTO = [
  'Bonifico',
  'Bonifico anticipato',
  'Bonifico 30gg',
  'Bonifico 60gg',
  'RiBa 30gg',
  'RiBa 60gg',
  'RiBa 30/60gg (50%+50%)',
  'RiBa 30/60/90gg (3 rate)',
  'Contanti',
  'Assegno',
  'Rimessa diretta',
  'Altro'
];

export const CAUSALI_TRASPORTO = [
  'Vendita',
  'Conto visione',
  'Conto lavorazione',
  'Reso',
  'Riparazione',
  'Omaggio',
  'Altro'
];

export const ASPETTO_BENI = [
  'A vista',
  'Scatola/e',
  'Pallet',
  'Busta',
  'Sfuso',
  'Altro'
];

export const DOCUMENTO_LABELS = {
  preventivo: { label: 'Preventivo', color: 'bg-blue-500', icon: FileText },
  offerta: { label: 'Offerta', color: 'bg-purple-500', icon: FileText },
  ddt: { label: 'DDT', color: 'bg-amber-500', icon: Truck },
  fattura: { label: 'Fattura', color: 'bg-emerald-500', icon: Receipt },
  nota_credito: { label: 'Nota Credito', color: 'bg-red-500', icon: Receipt }
};

export const VOCE_VUOTA = { descrizione: '', quantita: 1, prezzo_unitario: 0, sconto_percentuale: 0, unita_misura: 'pz', evidenzia: false, escludi_totale: false, is_titolo: false };

export const DATI_DDT_VUOTI = {
  causale_trasporto: 'Vendita',
  aspetto_beni: 'A vista',
  peso_kg: '',
  numero_colli: 1,
  porto: 'Franco',
  vettore: '',
  data_trasporto: '',
  ora_trasporto: '',
  destinazione_diversa: ''
};

export const DATI_FATTURA_VUOTI = {
  data_scadenza_pagamento: '',
  codice_destinatario_sdi: '',
  pec_destinatario: '',
  riferimento_ddt: '',
  riferimento_ordine: '',
  pagato: false,
  metodo_pagamento_sdi: ''
};
